import dotProp from 'dot-prop-immutable'
import {
  LOAD_EXAMPLE_SUCCESS,
  CHANGE_EXAMPLE_SUCCESS,
  CREATE_EXAM_SUCCESS,
  CHOOSE_EXAM_SUCCESS,
  LOAD_CATEGORYEXAM_SUCCESS,
  LOAD_LISTEXAM_SUCCESS,
  SAVE_SECTION_SUCCESS,
  // LOAD_EXAMOVERVIEW_SUCCESS,
  SET_TIMER_SUCCESS,
  SET_EXAMPLE_SUCCESS,
  LOAD_SUBCATEGORYEXAM_SUCCESS,
  SET_TIMESTART_SUCCESS,
  SUBMIT_ANSWER_SUCCESS,
  SUBMIT_REVIEWEXAM_SUCCESS,
  DELETE_REVIEWEXAM_SUCCESS,
  SAVE_EXAMPLE_SUCCESS,
  LOAD_QUESTIONEXAM_SUCCESS,
  SUBMIT_ANSWER_FAILURE,
  SUBMIT_ANSWER_REQUEST,
  SET_INTERNET_FAILURE,
  LOAD_ARTICLE_SUCCESS,
  LOAD_HISTORYTESTEXAM_SUCCESS,
  LOAD_PACKAGE_SUCCESS,
} from '../actions/types'
import { token } from '../utils'

const initialState = {
  exampleTest: [
    {
      question: 'test1',
      choice: [
        {
          text: 'Atext',
          image: 'AImage',
        },
        {
          text: 'Btext',
          image: 'BImage',
        },
        {
          text: 'Ctext',
          image: 'CImage',
        },
        {
          text: 'Dtext',
          image: 'DImage',
        },
      ],
    },
    {
      question: 'test2',
      choice: [
        {
          text: 'Atext',
          image: 'AImage',
        },
        {
          text: 'Btext',
          image: 'BImage',
        },
        {
          text: 'Ctext',
          image: 'CImage',
        },
        {
          text: 'Dtext',
          image: 'DImage',
        },
      ],
    },
    {
      question: 'test3',
      choice: [
        {
          text: 'Atext',
          image: 'AImage',
        },
        {
          text: 'Btext',
          image: 'BImage',
        },
        {
          text: 'Ctext',
          image: 'CImage',
        },
        {
          text: 'Dtext',
          image: 'DImage',
        },
      ],
    },
    {
      question: 'test4',
      choice: [
        {
          text: 'Atext',
          image: 'AImage',
        },
        {
          text: 'Btext',
          image: 'BImage',
        },
        {
          text: 'Ctext',
          image: 'CImage',
        },
        {
          text: 'Dtext',
          image: 'DImage',
        },
      ],
    },
    {
      question: 'test5',
      choice: [
        {
          text: 'Atext',
          image: 'AImage',
        },
        {
          text: 'Btext',
          image: 'BImage',
        },
        {
          text: 'Ctext',
          image: 'CImage',
        },
        {
          text: 'Dtext',
          image: 'DImage',
        },
      ],
    },
    {
      question: 'test6',
      choice: [
        {
          text: 'Atext',
          image: 'AImage',
        },
        {
          text: 'Btext',
          image: 'BImage',
        },
        {
          text: 'Ctext',
          image: 'CImage',
        },
        {
          text: 'Dtext',
          image: 'DImage',
        },
      ],
    },
    {
      question: 'test7',
      choice: [
        {
          text: 'Atext',
          image: 'AImage',
        },
        {
          text: 'Btext',
          image: 'BImage',
        },
        {
          text: 'Ctext',
          image: 'CImage',
        },
        {
          text: 'Dtext',
          image: 'DImage',
        },
      ],
    },
    {
      question: 'test8',
      choice: [
        {
          text: 'Atext',
          image: 'AImage',
        },
        {
          text: 'Btext',
          image: 'BImage',
        },
        {
          text: 'Ctext',
          image: 'CImage',
        },
        {
          text: 'Dtext',
          image: 'DImage',
        },
      ],
    },
    {
      question: 'test9',
      choice: [
        {
          text: 'Atext',
          image: 'AImage',
        },
        {
          text: 'Btext',
          image: 'BImage',
        },
        {
          text: 'Ctext',
          image: 'CImage',
        },
        {
          text: 'Dtext',
          image: 'DImage',
        },
      ],
    },
    {
      question: 'test10',
      choice: [
        {
          text: 'Atext',
          image: 'AImage',
        },
        {
          text: 'Btext',
          image: 'BImage',
        },
        {
          text: 'Ctext',
          image: 'CImage',
        },
        {
          text: 'Dtext',
          image: 'DImage',
        },
      ],
    },
  ],
  currExam: 0,
  choiceExam: [],
  categories: [],
  packages: [],
  listExam: {
    exam: [],
  },
  examOverviews: [],
  examReview: {
    comments: [],
    rating1: 0,
    rating2: 0,
    rating3: 0,
    rating4: 0,
    rating5: 0,
  },
  examRelate: [],
  courseRelated: [],
  exam: {
    questions: [],
  },
  timer: 0,
  historyPage: [],
  timeStart: [],
  chart: [],
  history: [],
  myScore: 0,
  newExam: [],
  popularExam: [],
  allExam: [],
  tags: [],
  article: [],
  rankstat: {
    myScore: 0,
    timer: 0,
    chart: {},
    history: {},
  },
  ranking: 0,
  relatedProduct: {
    courseRecommended: [],
    examRecommended: [],
  },
  rankStat: {
    numplayer: 0,
    detailScore: [],
  },
  charts: {
    rankChart: {
      myScore: {},
      points: [],
    },
  },
  connectErr: false,
  liveExamHistory: {
    graph: [],
    myRanking: 0,
    rankstat: [],
    tag: [],
    customer:{
      displayName:'',
    }
  }
}
const createSelectedChoice = (
  exampleTest) => {
  let list = []
  exampleTest.map((key, number) =>
    list.push({
      index: number,
      selected: 0,
      status: number === 0 ? 1 : 0,
      priority: 0,
      _id: key._id,
    })
  )
  return list
}
const updateCommented = (state, action) => {
  let newState = dotProp.merge(state, 'examReview.comments', {
    comment: action.payload.comment,
    customer: action.payload.customer,
    date: action.payload.date,
    isMyComment: token === '' ? false : true,
    rating: action.payload.rating,
    _id: action.payload._id,
  })
  return {
    ...newState,
  }
}
const deleteCommented = (state, action) => {
  const { examReview: currentComment } = state
  const indexComment = currentComment.comments.findIndex(item => item._id === action.payload._id)
  if (indexComment > -1) {
    let newState = dotProp.delete(state, `examReview.comments.${indexComment}`)
    return {
      ...newState,
    }
  }
  return {
    ...state,
  }
}
const example = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_EXAMPLE_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }
    case CHANGE_EXAMPLE_SUCCESS:
      return {
        ...state,
        currExam: action.data,
      }
    case CREATE_EXAM_SUCCESS:
      return {
        ...state,
        choiceExam: createSelectedChoice(action.data),
      }
    case LOAD_PACKAGE_SUCCESS:
      return {
        ...state,
        packages: action.payload,
      }
    case CHOOSE_EXAM_SUCCESS:
      return {
        ...state,
        choiceExam: action.data,
      }
    case LOAD_ARTICLE_SUCCESS:
      return {
        ...state,
        article: action.payload,
      }
    case LOAD_CATEGORYEXAM_SUCCESS:
      {
        return {
          ...state,
          // ...action.payload,
          // categoryExam: action.payload,
          ...action.payload,
        }
      }
    case LOAD_SUBCATEGORYEXAM_SUCCESS:
      {
        return {
          ...state,
          // ...action.payload,
          // categoryExam: action.payload,
          categories: action.payload,
        }
      }
    case LOAD_LISTEXAM_SUCCESS:
      {
        return {
          ...state,
          // ...action.payload,
          // categoryExam: action.payload,
          listExam: action.payload,
        }
      }
    case SAVE_SECTION_SUCCESS:
      {
        return {
          ...state,
          // ...action.payload,
          // categoryExam: action.payload,
          categories: action.data,
        }
      }
    // case LOAD_EXAMOVERVIEW_SUCCESS:
    //   {
    //     return {
    //       ...state,
    //       // ...action.payload,
    //       // categoryExam: action.payload,
    //       // ...action.payload,
    //       exam: action.payload.product.exams,
    //     }
    //   }
    case SET_TIMER_SUCCESS:
      {
        return {
          ...state,
          timer: action.data,
        }
      }
    case SAVE_EXAMPLE_SUCCESS:
      {
        return {
          ...state,
          ...action.data,
        }
      }
    case SET_TIMESTART_SUCCESS:
      {
        return {
          ...state,
          timeStart: action.data,
        }
      }
    case SUBMIT_ANSWER_SUCCESS:
      {
        return {
          ...state,
          ...action.payload,
        }
      }
    case LOAD_HISTORYTESTEXAM_SUCCESS:
      {
        return {
          ...state,
          liveExamHistory: action.payload,
        }
      }
    case SUBMIT_ANSWER_REQUEST:
      {
        if (action.error === true) {
          return {
            ...state,
            connectErr: true,
          }
        }
        return {
          ...state,
          // ...action.payload,
        }
      }
    case SUBMIT_ANSWER_FAILURE:
      {
        return {
          ...state,
          ...action.payload,
          ...action.meta,
          connectErr: action,
        }
      }
    case SET_INTERNET_FAILURE:
      {
        return {
          ...state,
          connectErr: action.data,
        }
      }
    case LOAD_QUESTIONEXAM_SUCCESS:
      {
        return {
          ...state,
          exam: {
            questions: action.payload,
          },
        }
      }
    case SET_EXAMPLE_SUCCESS:
      {
        return {
          ...state,
          exam: action.data,
        }
      }
    case SUBMIT_REVIEWEXAM_SUCCESS: return updateCommented(state, action)
    case DELETE_REVIEWEXAM_SUCCESS:
      return deleteCommented(state, action)
    default:
      return state
  }
}

export default example




// WEBPACK FOOTER //
// ./src/reducers/example.js